/**
 * CtaSection — the download/CTA strip near the bottom of the page.
 * Paths: cta.{heading, body, downloadFor, android, ios, soonBadge,
 *             iosAlert, altWeb, altDashboard, webButton, dashboardButton}
 *
 * Plus brand.androidUrl + brand.iosUrl for the actual download links.
 * (Brand-level URLs live under brand.* so they can be edited in the Logo
 * section too — but it's easier to find them here next to the buttons.)
 */

import {
  BilingualTextField, BilingualTextareaField,
  SectionPanel, UrlField,
} from '../fields/BilingualFields'

export default function CtaSection({ getField, setField }) {
  const androidUrl = getField('en', 'brand.androidUrl', '') ||
                     'https://drive.google.com/drive/folders/1JIaqThihR35PITbFkXOSbwVyIEhm3WV0?usp=sharing'

  const setAndroidUrl = (val) => {
    setField('en', 'brand.androidUrl', val)
    setField('ar', 'brand.androidUrl', val)
  }

  return (
    <SectionPanel title="CTA / Download" subtitle="Ready-to-get-started block + app store buttons">
      <BilingualTextField label="Heading" path="cta.heading" getField={getField} setField={setField} />
      <BilingualTextareaField label="Body" path="cta.body" getField={getField} setField={setField} rows={3} />

      <hr className="my-3 border-gray-200" />
      <h4 className="text-sm font-semibold text-gray-700 mb-2">Download buttons</h4>
      <BilingualTextField label='Small label above app name ("Download for")' path="cta.downloadFor" getField={getField} setField={setField} />
      <BilingualTextField label="Android button label" path="cta.android" getField={getField} setField={setField} />
      <BilingualTextField label="iOS button label" path="cta.ios" getField={getField} setField={setField} />
      <BilingualTextField label='iOS "Soon" badge' path="cta.soonBadge" getField={getField} setField={setField} />
      <BilingualTextareaField label="iOS alert text (shown when iOS button clicked)" path="cta.iosAlert" getField={getField} setField={setField} rows={2} />

      <UrlField
        label="Android download URL"
        value={androidUrl}
        onChange={setAndroidUrl}
        placeholder="https://play.google.com/... or Drive link"
      />

      <hr className="my-3 border-gray-200" />
      <h4 className="text-sm font-semibold text-gray-700 mb-2">Web fallback</h4>
      <BilingualTextField label='Text before button (unauthenticated)' path="cta.altWeb" getField={getField} setField={setField} />
      <BilingualTextField label='Text before button (logged-in)' path="cta.altDashboard" getField={getField} setField={setField} />
      <BilingualTextField label='Web button label (unauthenticated)' path="cta.webButton" getField={getField} setField={setField} />
      <BilingualTextField label='Web button label (logged-in)' path="cta.dashboardButton" getField={getField} setField={setField} />
    </SectionPanel>
  )
}
